import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { resetUser } from 'src/modules/Users/actions'
import { resetApp, closeSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'
import { setDropdownVisibility } from 'src/modules/App/nonPersistentActions'
import { getFromSettings } from 'src/utils/helpers'

import Dropdown from './Dropdown'

const mapDispatchToProps = {
  resetUser,
  resetApp,
  closeSidebar,
  setCurrentlyOpenFeature,
  setDropdownVisibility,
}

const mapStateToProps = (state) => {
  return {
    features: getFromSettings(state, 'features', {}),
    labels: getFromSettings(state, 'labels', {}),
    dropdownsVisibility: state.nonPersistentAppReducer.dropdownsVisibility,
    user: state.user.user,
    userLastAccessType: state.user.userLastAccessType,
    language: state.appReducer.language,
    featureFlags: getFromSettings(state, 'featureFlags', []),
    countryIsoCode: getFromSettings(state, 'countryIsoCode'),
    areAppActionsDisabled: state.nonPersistentAppReducer.areAppActionsDisabled,
    isWidgetState: state.appReducer.isWidget,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dropdown))
